import React from 'react';
import PropTypes from 'prop-types';

import CalloutBox from './callout-box';

const CalloutBoxAssembly = ({ contentfulData }) => (
  <CalloutBox
    heading={contentfulData?.heading}
    content={contentfulData?.content}
  />
);

CalloutBoxAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

export default CalloutBoxAssembly;
